(() => {
  const creditSelector = '.wine-regions__photo-credit';
  const summarySelector = creditSelector + ' > summary';
  const openSelector = creditSelector + '[open]';
  const isMouse = (event) => event.pointerType === 'mouse';
  const closeOthers = (credit) => {
    document.querySelectorAll(openSelector).forEach((other) => {
      if (other !== credit) other.open = false;
    });
  };

  document.addEventListener('pointerover', (event) => {
    const summary = event.target.closest(summarySelector);
    if (!summary || !isMouse(event)) return;
    const credit = summary.parentElement;
    closeOthers(credit);
    credit.open = true;
  });

  document.addEventListener('pointerout', (event) => {
    const credit = event.target.closest(openSelector);
    if (credit && isMouse(event) && !credit.contains(event.relatedTarget)) credit.open = false;
  });

  document.addEventListener('click', (event) => {
    const mouseClick = isMouse(event) || (!event.pointerType && event.detail > 0 &&
      matchMedia('(hover: hover) and (pointer: fine)').matches);
    if (event.target.closest(summarySelector) && mouseClick) event.preventDefault();
  });

  document.addEventListener('toggle', (event) => {
    if (event.target.matches(openSelector)) closeOthers(event.target);
  }, true);

  document.addEventListener('pointerdown', (event) => {
    closeOthers(event.target.closest(creditSelector));
  });

  document.addEventListener('focusout', (event) => {
    const credit = event.target.closest(openSelector);
    if (credit && !credit.contains(event.relatedTarget)) credit.open = false;
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const credit = document.querySelector(openSelector);
    if (!credit) return;
    const focusWithin = credit.contains(document.activeElement);
    credit.open = false;
    if (focusWithin) credit.querySelector('summary').focus();
  });
})();
